import * as React from 'react';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import { CardActionArea } from '@mui/material';
import RoadmapOverlay from './RoadmapOverlay';
import Box from '@mui/material/Box';
import { CookingPot } from './CookingSoon';
import RoadmapCards from './RoadmapCards';
// import { useNavigate } from 'react-router-dom';

export default function DSCourseCard({sx, topicName, questions, index, cooking=false}) {
    function getMiniRoadmap(index) {
        if (index === 2) {
            return (
                <>
                    <Box sx={{
                        width: '100%',
                        height: '100%',
                        minWidth: 'max-content',
                        backgroundImage: "url('/icons/Mini Roadmap Line.svg')",
                        backgroundRepeat: 'no-repeat',
                        backgroundSize: '100% auto',
                        backgroundPosition: 'center',
                    }}>

                    </Box>
                    <Box sx={{
                        position: 'absolute',
                        width: '100%',
                        height: '100%',
                        display: 'flex', 
                        alignItems: 'center',
                        justifyContent: 'space-around',
                        padding: 5,
                    }}> 

                        {questions.slice(0,3).map((item, index) => {

                            return ( 
                                <Box>
                                    <RoadmapCards key={index} data={item} cardPosition={index % 2} type={"minimap"} index={index} identifier={`question${index}`}/>  
                                </Box>
                            )

                        })}

                    </Box>
                </>
            )
        }
    }

    return (
        <Card sx={sx}>
            <Box sx={{height: '100%'}}>
                <CardContent sx={{height:'100%', display: 'flex', flexDirection: 'column', alignItems:'center', justifyContent: 'start' }}>
                    <Typography gutterBottom variant="h6" component="div"> 
                    {topicName}
                    </Typography>
                    <Box
                        sx={{
                            position: 'absolute',
                            top: 10,
                            left: '85%',
                            zIndex: 1,
                        }}>
                            {index === 2 ? <RoadmapOverlay name={topicName} questions={questions}/> : <></>}
                    </Box>
                    
                    {getMiniRoadmap(index)}
                </CardContent>
            </Box>
        </Card>
    );
}